import React from 'react'

const ArrowDownTransparentBlackSvg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 8.769 4.76'
    >
      <path
        id='Path_3140'
        data-name='Path 3140'
        d='M347.545,507.2l3.854,3.854,3.854-3.854'
        transform='translate(-347.015 -506.666)'
        fill='none'
        stroke='#343434'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.75'
      />
    </svg>
  )
}

export default ArrowDownTransparentBlackSvg
